module.exports = __webpack_public_path__ + "images/product_pickle_3.35b64dfd.jpg";